import React from "react"
import { useContext } from "react"
import { WebEditorContext } from "../../../../../contexts";
import "./styles.scss"
import DxmlSpan from "./DxmlSpan";

export default function DxmlRun({ editorRun, inForm }) {
    const { editorFileRef } = useContext(WebEditorContext);
    const editorFontDef = editorFileRef.current.EditorFontLibrary?.Fonts.find(x => x.Id === editorRun.EditorFontDefId);

    return (
        <>
            {
                (inForm === true)
                    ?
                    (
                        <tspan style={editorRun.ReactCssStyle} x={editorRun.TSpanX} y={editorRun.TSpanY}>
                            {editorRun.HtmlContent}
                        </tspan>
                    )
                    :
                    (
                        <DxmlSpan text={editorRun.HtmlContent} cssStyle={editorRun.ReactCssStyle} editorFontDef={editorFontDef} />
                    )
            }
        </>
    )
}
